import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Avatar, LegalString, Text } from '@stashinvest/react-components';
import { Box, Flex, PrimaryButton, TertiaryButton } from '@stashinvest/ui';
import { BanjoString } from '@stashinvest/react-banjo';
import LearnMorePlaidDataSharing from './LearnMorePlaidDataSharing';
import { BankIcon } from '@stashinvest/react-assets';
import useTrack from 'stash/hooks/useTrack';
import {
	v1_ExternalAccountLink_Clicked,
	v1_ExternalAccountLink_Viewed,
} from '@stashinvest/product-events-javascript/lib/v1/event_static_methods';
import {
	v1_ExternalAccountLink_ClickedProperties,
	v1_ExternalAccountLink_ViewedProperties,
} from '@stashinvest/product-events-javascript/lib/v1/properties';
import { Screen } from '@stashinvest/product-events-javascript/lib/enum_properties';

export const LinkBankTypeSelect = ({ onBankSelect, onMicrosSelect }) => {
	const track = useTrack();

	useEffect(() => {
		track(
			v1_ExternalAccountLink_Viewed({
				external_account_type:
					v1_ExternalAccountLink_ViewedProperties.ExternalAccountType?.bank,
			})
		);
	}, [track]);
	return (
		<Box className="mx-contentMedium">
			<Flex flexDirection="column" alignItems="center">
				<Avatar
					shape="square"
					backgroundType="fill"
					variant={{
						type: 'icon',
						Icon: BankIcon,
						size: 'medium',
						variant: 'neutral',
					}}
				/>
			</Flex>
			<Text
				tag="h2"
				textStyle="headerSmall"
				textAlign="center"
				className="my-contentSmall"
			>
				<BanjoString stringId="information/instruct/linkBankInstant" />
			</Text>
			<Text tag="p" textStyle="bodyMediumStandard">
				<BanjoString stringId="information/giveContext/linkBankInstant" />
			</Text>
			<div className="my-content2XS">
				<LearnMorePlaidDataSharing />
			</div>
			<Text tag="p" textStyle="bodyMediumStandard" className="pb-contentSmall">
				<BanjoString stringId="information/giveContext/linkBankInstantUses" />
			</Text>
			<LegalString color="supporting" className="py-contentSmall">
				<BanjoString stringId="information/disclose/linkedSavingsAccount" />
			</LegalString>
			<PrimaryButton
				className="my-contentXS"
				data-testid="instant-option"
				onClick={() => {
					track(
						v1_ExternalAccountLink_Clicked({
							screen: Screen.externalAccountLinkMain,
							external_account_type:
								v1_ExternalAccountLink_ClickedProperties.ExternalAccountType?.bank,
							external_account_connection_type:
								v1_ExternalAccountLink_ClickedProperties.ExternalAccountConnectionType
									?.instant,
						})
					);
					onBankSelect();
				}}
			>
				<BanjoString stringId="action/progress/nextScreen" />
			</PrimaryButton>
			<TertiaryButton
				className="my-contentXS"
				data-testid="manual-option"
				onClick={() => {
					track(
						v1_ExternalAccountLink_Clicked({
							screen: Screen.externalAccountLinkMain,
							external_account_type:
								v1_ExternalAccountLink_ClickedProperties.ExternalAccountType?.bank,
							external_account_connection_type:
								v1_ExternalAccountLink_ClickedProperties.ExternalAccountConnectionType
									?.microDeposits,
						})
					);
					onMicrosSelect();
				}}
			>
				<BanjoString stringId="action/startTask/linkBankManually" />
			</TertiaryButton>
		</Box>
	);
};

LinkBankTypeSelect.propTypes = {
	onBankSelect: PropTypes.func,
	onMicrosSelect: PropTypes.func,
};

export default LinkBankTypeSelect;
